<template>
  <GuBadge v-if="value" :variant="badgeVariant">
    {{ value }}
  </GuBadge>
  <span v-else-if="emptyValueText" :class="[emptyValueClass || 'gu-datagrid-empty-value']">
    {{ emptyValueText }}
  </span>
</template>

<script setup>
import { GuBadge } from '@shared/gu-components/badge'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const {
  value,
  //
  variant,
  emptyValueText,
  emptyValueClass,
} = props.params

const badgeVariant = variant[value] || 'light'
</script>
